import { render, staticRenderFns } from "./GardeDetail.vue?vue&type=template&id=8555774e"
import script from "./GardeDetail.vue?vue&type=script&lang=js"
export * from "./GardeDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports